<template>
  <div class="pageContainer">
    <main role="main">

      <div v-if="!user" id="static-homepage">
        <!-- Main jumbotron for a primary marketing message or call to action -->
        <div class="jumbotron">
          <div class="container">
            <h1 class="display-3">Become Your Best Self</h1>
            <p>An easy-to-use, goal-oriented social network focused on helping you become the best version of yourself. Set your goals, stay accountable with friends, and participate in challenges that earn you real money for achieving them!</p>
            <p><router-link class="btn btn-primary btn-lg" :to="{ name: 'Join' }">Join Now</router-link></p>
          </div>
        </div>

        <div class="container">
          <!-- Example row of columns -->
          <div class="row">
            <div class="col-md-4">
              <h2>Create Goals With Friends</h2>
              <p>Set weekly goals that align with the life you want to live and invite friends to hold you accountable.</p>
            </div>
            <div class="col-md-4">
              <h2>Post Proof &amp; Follow Others</h2>
              <p>Prove you completed your goals by posting about it and grow your followers to influence others with your lifestyle. You can follow others and even adopt the routines and habits of people who inspire you the most.</p>
            </div>
            <div class="col-md-4">
              <h2>Compete &amp; Earn Coins</h2>
              <p>Participate in challenges or create your own with friends and bet on yourself. Competing and completing challenges earn you coins, which you can use for other challenges or trade back for <strong>real money</strong>.</p>
            </div>
          </div>
          <hr>
        </div> <!-- /container -->
      </div>

      <div v-if="user" id="dashboard">
        <div class="container">
          <div class="row">
            <div class="col-3">
              <div class="list-group">
                <a href="#" class="list-group-item list-group-item-action">Dave</a>
                <a href="#" class="list-group-item list-group-item-action">Goals</a>
                <a href="#" class="list-group-item list-group-item-action">Friends</a>
                <a href="#" class="list-group-item list-group-item-action">Badges</a>
                <a href="#" class="list-group-item list-group-item-action">Groups</a>
              </div>
            </div>
            <div class="col-5">

              <PostBox />
              <Post />

            </div>
            <div class="col-4">

              <TrackGoals :goals="goals" />

            </div>
          </div>
        </div>
      </div>

    </main>
  </div>
</template>

<script>
import firebase from 'firebase'
import db from '@/store/firebaseinit'
import Navbar from '@/components/utility/Navbar'
import PostBox from '@/components/utility/PostBox'
import TrackGoals from '@/components/goals/components/TrackGoals'
import Post from '@/components/utility/Post'

export default {
  name: 'Index',
  components: {
    Navbar,
    TrackGoals,
    PostBox,
    Post
  },
  data () {
    return {
      user: {
        username: null,
      },
      goals: [{
        title: 'Workout In The Gym realy really hard',
        category: 'fitness'
      },{
        title: 'Work On Proove',
        category: 'career'
      },{
        title: 'Read Your Books',
        category: 'intellect'
      }]
    }
  },
  watch: {

  },
  beforeCreate() {
    if(firebase.auth().currentUser) {
      this.user = firebase.auth().currentUser
      db.collection('users').doc(this.user.uid).get()
      .then(result => {
        this.user.username = result.data().username
      }).catch(error => {
        console.log(error.message)
      })
    }
  },
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      if(user) {
        this.user = firebase.auth().currentUser
        this.ListenForProfileUpdates()
      } else {
        this.first = null
        this.user = null
      }
    })
  },
  methods: {
    ListenForProfileUpdates() {
      // Listen for updates to user information
      let ref = db.collection('users').doc(this.user.uid)
      ref.onSnapshot(snapshot => {
        this.user = firebase.auth().currentUser
        if(this.user) {
          var displayName = this.user.displayName.split(" ")
          this.first = displayName[0]
          this.username = snapshot.data().username
        }
      })
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .jumbotron {
    border-radius: 0;
  }
  h2 {
    font-size: 24px;
  }
  body {
    min-width: 500px !important;
  }
  #dashboard {
    margin-top: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Index.vue